import { MouseEventHandler } from 'react';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import {
  TagLocation,
  TagStyled,
  TagTextStyled,
  TagVariant,
} from './Tag.styles';

interface Props {
  variant?: TagVariant;
  tagLocation?: TagLocation;
  text: string;
  onClick?: MouseEventHandler;
  'data-testid'?: string;
  className?: string;
  readOnly?: boolean;
  hideCloseIcon?: boolean;
  customColor?: string;
  size?: 'medium' | 'small';
  flexToFitSpace?: boolean;
}

export const Tag = ({
  variant = 'default',
  tagLocation,
  text,
  onClick,
  className,
  customColor,
  size = 'medium',
  ...props
}: Props) => {
  const theme = useTheme();
  return (
    <TagStyled
      variant={variant}
      aria-readonly={props.readOnly}
      tagLocation={tagLocation}
      data-testid={props['data-testid']}
      className={className}
      customColor={customColor}
      size={size}
      flexToFitSpace={props.flexToFitSpace}
    >
      <TagTextStyled noWrap={props.flexToFitSpace} title={text}>
        {text}
      </TagTextStyled>
      {!props.readOnly && !props.hideCloseIcon && (
        <StyledIcon
          className="uil uil-times"
          size="16px"
          color={
            variant === 'disabled'
              ? theme.atlas.semantic.color.type.disabled
              : theme.atlas.semantic.color.type.default
          }
          onClick={variant === 'disabled' ? () => {} : onClick}
          onMouseDown={(e) => e.preventDefault()}
          data-testid="tag-x-icon"
        />
      )}
    </TagStyled>
  );
};
